import React from 'react';
import { Banner } from './Banner';
import { BrandInline } from './BrandInline';

export const Hero = () => {
  return (
    <section id="home" className="pt-8 pb-20">
      {/* Shared Banner + Pill (full size on Home) */}
      <Banner pillText="Sports &amp; Orthopedic Physical Therapy" reduced={false} />

      {/* Centered Content Section */}
      <div className="container">
        <div className="flex flex-col items-center text-center">
          {/* Headline */}
          <h1 className="mt-8 mb-6 font-extrabold leading-tight text-5xl lg:text-6xl">
            <strong style={{ color: 'var(--secondary-brown)' }}>GymRatRehab</strong> is offering Expert Physical Therapy services in <span style={{ color: 'var(--brand-primary)' }}>Gilbert, AZ</span>
          </h1>

          {/* Photo */}
          <div className="relative mb-12 flex justify-center">
            <div
              style={{
                width: '280px',
                height: '280px',
                backgroundImage:
                  'url(https://customer-assets.emergentagent.com/job_physio-blog-admin/artifacts/o65crtxj_headshot%20.jpg)',
                backgroundSize: 'contain',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                border: 'none',
                outline: 'none',
                borderRadius: '0',
                boxShadow: 'none'
              }}
              className="lg:w-[400px] lg:h-[400px]"
              aria-label="Douglas Mitchell, DPT - Physical Therapist"
            ></div>
          </div>

          {/* Credentials Pill under photo */}
          <div className="mb-6">
            <span className="inline-block px-4 py-2 text-sm font-semibold uppercase tracking-wide rounded-full" style={{ backgroundColor: 'rgba(232, 184, 109, 0.2)', color: 'var(--brand-primary)' }}>
              Douglas Mitchell, PT, DPT
            </span>
          </div>

          {/* Description */}
          <div className="mx-auto max-w-[900px] px-4">
            <p className="text-justify text-lg leading-relaxed mb-4">
              Here at <span className="font-bold uppercase tracking-wide" style={{ color: 'var(--secondary-brown)' }}>GYMRATREHAB</span>,
              {' '}I LOVE helping clients maximize their ability to heal. I have been providing expert Physical Therapy for years with a wide range of clients, from geriatric / home hospice patients, to working with weekend warrior athletes and professional athletes.
            </p>
            <p className="text-justify text-lg leading-relaxed">
              I am pleased to offer a unique opportunity for your recovery, with a <a href="/blog" className="font-bold" style={{ color: 'var(--brand-primary)' }}>CASH based</a> clinic. We are not bound by insurance protocols dictating what and how you can be treated. In the Blog section, I will be covering the benefits of <a href="/blog" className="font-bold" style={{ color: 'var(--brand-primary)' }}>CASH based</a> healthcare, and why it actually will save you time and money.
            </p>
            <p className="text-justify text-lg leading-relaxed mt-4">
              Welcome to <span className="font-bold uppercase tracking-wide" style={{ color: 'var(--secondary-brown)' }}>GYMRATREHAB</span>, Physical Therapy for YOU.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};